import measureScrollBarWidth from './measure-scroll-bar-width'

export default function setScrollbarCssVar() {
  const scrollBarWidth = measureScrollBarWidth()
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${scrollBarWidth}px`
  )
}
